import LoadingScreen from "@components/Onboarding/LoadingScreen";

export default LoadingScreen;
